import { gql } from "@apollo/client";

const CREATE_SUBSCRIPTION_INTENT = gql`
  mutation CreateSubscriptionIntent($customerId: String!) {
    createSubscriptionIntent(customerId: $customerId) {
      success
      error
      result
    }
  }
`;
export default CREATE_SUBSCRIPTION_INTENT;
